import { APICore } from './apiCore'

const api = new APICore()

function getEventsContacts (params) {
  const baseUrl = '/events-contacts'
  return api.get(baseUrl, params)
}

function getEventsContact (id) {
  const baseUrl = `/events-contacts/${id}`
  return api.get(baseUrl, {})
}

function addEventsContact (params) {
  const baseUrl = '/events-contacts'
  return api.create(baseUrl, params)
}

function updateEventsContact (params) {
  const baseUrl = '/events-contacts'
  return api.update(baseUrl, params)
}

function deleteEventsContact (params) {
  const baseUrl = '/events-contacts'
  return api.delete(baseUrl, params)
}

export { getEventsContacts, getEventsContact, addEventsContact, updateEventsContact, deleteEventsContact }
